import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XCircleIcon } from '@heroicons/react/outline'

type Props = {
  title: string
  children: React.ReactNode
  isOpen: boolean
  addClass?: string
  signupModel? : boolean
  handleClose: () => void
  iframeModel? : boolean
}

export const BaseModal = ({
  title,
  addClass,
  children,
  isOpen,
  handleClose,
  signupModel,
  iframeModel,
}: Props) => {
  const checkmodel = ()=> {
    if(signupModel){
    localStorage.setItem('ModelStatus', '0');
    }else{
      return false;
    }
  }
  const checkModelClose = () => {
    if(!signupModel && !iframeModel ){
      handleClose();
    }
  }

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={checkModelClose}
      >
        <div className="flex items-center justify-center min-h-screen py-10 px-4 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0" 
          >
            <Dialog.Overlay  onClick={(e:any) => e.stopPropagation()} className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              className={`inline-block ${
                addClass ? addClass : ''
              } align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6 dark:bg-gray-800`}
            >
              <div className="absolute right-4 top-4">
                {/* <XCircleIcon
                  className="h-6 w-6 cursor-pointer dark:stroke-white"
                  onClick={() => handleClose()}
                /> */}
                <img style={{height:'18px', width:'18px', marginRight:'2px'}} src='/x-lg.png'
                  className="h-6 w-6 cursor-pointer dark:stroke-white"
                  onClick={() => { handleClose(); checkmodel(); }}
                />
              </div>
              <div>
                <div className="text-center">
                  <Dialog.Title
                    as="h3"
                    className="text_lg  leading-6 font-medium text-gray-900 dark:text-gray-100"
                  >
                    {title}
                  </Dialog.Title>
                  <div className="mt-2">{children}</div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
